export default __webpack_public_path__ + "static/media/116-BN-304.abc44d87.png";